<template>
    <CardPage :section="6" :page="5">
        <ResponsiveImage :src="require('@/assets/assertiveness/assertiveness_whatElse.png')"></ResponsiveImage>
        <p class="headline text-xs-center">
            What Else?
        </p>
        <p>
            Is there something else you like to do to center yourself? Write that here as a reminder.
        </p>
        <v-textarea outline auto-grow v-model="myStrategy"></v-textarea>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
    computed: {
        myStrategy: sync('section6/myStrategy')
    }
};
</script>
